<template>
  <app-timeline>
    <app-timeline-item
      v-for="(comment,index) in data"
      :key="index"
      :title="`Comment by ${comment.UserName}`"
      :subtitle="comment.Comment + ''"
      icon="MessageSquareIcon"
      :time="comment.UpdatedAt | date"
      variant="success"
      :data="comment"
      :show-delete="true"
      :onDelete="onDelete"
    />

  </app-timeline>
</template>

<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from './CandidateTimelineItem.vue'

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      
    }
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    onDelete: {
      type: Function,
      default: null
    }
  },
  methods: {
  }
}
</script>
